"use client";

import { Input } from "@headlessui/react";
import { debounce } from "lodash";
import { useCallback, useEffect, useMemo, useState } from "react";
import TabsFilter from "./TabsFilter";

const SelectGebruikers = ({
  setType,
  setRole,
  search = "",
  onSearchChange,
  activeTab,
  setActiveTab,
}) => {
  const [localSearch, setLocalSearch] = useState(search);

  const selectTab = useCallback(
    (role, type) => {
      setType(type);
      setRole(role);
    },
    [setRole, setType]
  );

  const debouncedSearch = useMemo(
    () => debounce((searchQuery) => onSearchChange?.(searchQuery), 300),
    [onSearchChange]
  );

  useEffect(() => {
    setLocalSearch(search);
  }, [search]);

  useEffect(() => () => debouncedSearch.cancel(), [debouncedSearch]);

  const tabs = [
    {
      id: 1,
      name: "Alle gebruikers",
      onClick: () => {
        selectTab(null, "all");
        setActiveTab("Alle gebruikers");
      },
    },
    {
      id: 2,
      name: "Specialisten",
      onClick: () => {
        selectTab(1, "role");
        setActiveTab("Specialisten");
      },
    },
    {
      id: 3,
      name: "Patienten",
      onClick: () => {
        selectTab(2, "role");
        setActiveTab("Patienten");
      },
    },
    {
      id: 4,
      name: "Niet Ingeschreven",
      onClick: () => {
        selectTab(999, "role");
        setActiveTab("Niet Ingeschreven");
      },
    },
  ];

  return (
    <div className="border-b border-wa-border bg-wa-app">
      <div className="m-0 flex flex-col gap-3 px-3 py-3 sm:px-4">
        <TabsFilter data={tabs} activeTab={activeTab} variant="wa" />
        <div className="min-w-0">
          <Input
            placeholder="Zoeken"
            className="block w-full rounded-lg border border-wa-border bg-wa-panel py-2.5 pl-3 pr-3 text-sm text-wa-text outline-none ring-0 placeholder:text-wa-muted focus:border-wa-accent focus:ring-1 focus:ring-wa-accent sm:text-sm/6"
            value={localSearch}
            onChange={(event) => {
              const nextSearch = event.target.value;
              setLocalSearch(nextSearch);
              debouncedSearch(nextSearch);
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default SelectGebruikers;
